import Skeleton from '../skeleton/Skeleton';
import { StyledContactsTableSkeleton } from './Contacts.styles';

const ROW_COUNT = 8;

const ContactRowSkeleton = () => (
  <tr className="skeleton-row">
    <td className="col-check">
      <Skeleton width={14} height={14} radius="4px" resp />
    </td>
    <td>
      <div className="skeleton-contact">
        <Skeleton width={40} height={40} radius="18px" resp />
        <div className="skeleton-contact-lines">
          <Skeleton width={128} height={14} radius="6px" resp />
          <Skeleton width={168} height={12} radius="6px" resp margin="6px 0 0" />
        </div>
      </div>
    </td>
    <td>
      <Skeleton width={100} height={14} radius="6px" resp />
      <Skeleton width={72} height={11} radius="6px" resp margin="6px 0 0" />
    </td>
    {/* Source and Agent / Campaign are parked in the real table. */}
    <td>
      <Skeleton width={72} height={20} radius="14px" resp />
    </td>
    <td className="col-score">
      <Skeleton width={40} height={26} radius="14px" resp />
    </td>
    <td>
      <Skeleton width={80} height={12} radius="6px" resp />
    </td>
    <td className="col-actions">
      <div className="skeleton-actions">
        <Skeleton width={32} height={32} radius="14px" resp />
        <Skeleton width={32} height={32} radius="14px" resp />
        <Skeleton width={32} height={32} radius="14px" resp />
        <Skeleton width={32} height={32} radius="14px" resp />
        <Skeleton width={32} height={32} radius="14px" resp />
      </div>
    </td>
  </tr>
);

export default function ContactsTableSkeleton() {
  return (
    <StyledContactsTableSkeleton>
      <div className="table-scroll">
        <table className="contacts-table">
          <thead>
            <tr>
              <th className="col-check" />
              <th>Contact</th>
              <th>Company</th>
              <th>Stage</th>
              <th className="col-score">AI Score</th>
              <th>Last touch</th>
              <th className="col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: ROW_COUNT }, (_, i) => (
              <ContactRowSkeleton key={i} />
            ))}
          </tbody>
        </table>
      </div>
    </StyledContactsTableSkeleton>
  );
}
